import { create } from "zustand";
import { persist } from "zustand/middleware";
import { jwtDecode } from "jwt-decode";
import { IAuth, IAuthActions } from "@workspace/shared/core/types";

const initState: IAuth = {
  expiresIn: 0,
  refreshToken: null,
  accessToken: null,
  idToken: null,
};

interface AuthState extends IAuth, IAuthActions {}

export const authStore = create<AuthState>()(
  persist(
    (set) => ({
      ...initState,
      setAuthState: (payload) => set({ [payload.key]: payload.value }),
      clearAuthState: () => set({ ...initState }),
    }),
    {
      name: "admin-app-auth-storage",
    }
  )
);

export const isLoggedIn = () => {
  const state = authStore.getState();
  return Boolean(state.accessToken && state.refreshToken);
};

/**
 * Email of the signed-in user, decoded from the persisted Cognito idToken.
 * Works even when the token is EXPIRED (decode only, no verification) — used
 * to prefill the in-place re-login prompt after a session expires.
 */
export const getStoredUserEmail = (): string => {
  try {
    const idToken = authStore.getState().idToken;
    if (!idToken) return "";
    const decoded = jwtDecode(idToken) as { email?: string };
    return decoded?.email ?? "";
  } catch {
    return "";
  }
};
